import { CreateThirdPartyUserClientZoneAssignmentDTO, IPagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO, IThirdPartyUserClientZoneAssignmentDTO, IThirdPartyUserClientZoneAssignmentZoneInfoDTO, ThirdPartyUserClientZoneAssignmentClient, ThirdPartyUserClientZoneAssignmentUserInfoDTO } from '../../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { FilterDTO, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { ZonePathUtil } from 'src/app/base/shared/utils/zone-path.util';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class ThirdPartyUserAssignmentAdministrationService extends ShowInactiveService implements IAdaptorService {
  public readonly extendedZonePathFieldName = 'zone.' + ZonePathUtil.extendedZonePathFieldName;

  constructor(private toastService: ToastService, private tpuAssignmentClient: ThirdPartyUserClientZoneAssignmentClient) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO> {

    return this.tpuAssignmentClient.searchThirdPartyUserClientZoneAssignments(filters, skip, take, sortBy, sortDirection)
      .pipe(
        tap((result: IPagedResultDTOOfThirdPartyUserClientZoneAssignmentDTO) => {
          result.items.forEach((item: IThirdPartyUserClientZoneAssignmentDTO) => {
            ZonePathUtil.extendByZonePath(item.zone);
          });
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    return this.tpuAssignmentClient.deleteThirdPartyUserClientZoneAssignment(id)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.third-party-user-assignment-administration.messages.delete-title',
            'i18n.domain.third-party-user-assignment-administration.messages.delete-success-message'
          );
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public bulkDeleteRecords(userId: string, clientId: number): Observable<any> {
    return this.tpuAssignmentClient.bulkDeleteThirdPartyUserClientZoneAssignment(userId, clientId).pipe(
      tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.third-party-user-assignment-administration.messages.bulk-delete-title',
            'i18n.domain.third-party-user-assignment-administration.messages.bulk-delete-success-message'
          );
        }),
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }

  public createAssignments(userId: string, clientId: number, zoneIds: number[] | undefined): Observable<any> {
    return this.tpuAssignmentClient.createThirdPartyUserClientZoneAssignments(new CreateThirdPartyUserClientZoneAssignmentDTO({userId, clientId, zoneIds})).pipe(
      tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.third-party-user-assignment-administration.messages.add-title',
            'i18n.domain.third-party-user-assignment-administration.messages.add-success-message'
          );
        }),
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }

  public searchThirdPartyUsers(searchText: string): Observable<ThirdPartyUserClientZoneAssignmentUserInfoDTO[]> {
    return this.tpuAssignmentClient.searchThirdPartyUsers(searchText, 0, 10).pipe(
      tap(

      ),
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }
}
